module.exports = __webpack_public_path__ + "static/media/banner-full.e5d28c7e.png";